import React from 'react';
import styled from 'styled-components';
import Text from '../Text';
import { observer } from 'mobx-react';

@observer
class InputHeader extends React.Component {
  render() {
    const { label, error } = this.props;
    return (
      <div className="f f-between-center mb-sxx">
        <Text grayDarkMedium>{label}</Text>
        <Text error>{error}</Text>
      </div>
    );
  }
}

export default InputHeader;



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/InputHeader.js